var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.modalEditar,
          expression: "modalEditar"
        }
      ]
    },
    [
      _c(
        "q-modal",
        {
          attrs: { "content-css": { minWidth: "100vw", minHeight: "100vh" } },
          model: {
            value: _vm.modalEditar,
            callback: function($$v) {
              _vm.modalEditar = $$v
            },
            expression: "modalEditar"
          }
        },
        [
          _c(
            "q-card",
            [
              _c(
                "div",
                { staticClass: "pad-10" },
                [
                  _c("q-icon", {
                    staticStyle: { float: "left" },
                    attrs: { name: "fas fa-search" }
                  }),
                  _c("span", [_c("b", [_vm._v("  Visualizar processo")])]),
                  _c("q-btn", {
                    staticStyle: { "margin-top": "-2px", float: "right" },
                    attrs: {
                      flat: "",
                      rounded: "",
                      dense: "",
                      round: "",
                      size: "sm",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.modalEditar = false
                      }
                    }
                  })
                ],
                1
              ),
              _c("q-card-separator", {
                staticStyle: {
                  "font-weight": "bold",
                  "border-bottom": "1px solid rgb(9, 51, 112)"
                }
              }),
              _c("div", { staticClass: "gvn-cabecalho mrg-b-10" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                    [
                      _c("strong", [_vm._v("Nº do Processo / Ano: ")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(this.numProcesso) +
                          "/" +
                          _vm._s(this.anoProcesso) +
                          "\n          "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                    [
                      _c("strong", [_vm._v("Status atual: ")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(this.statusAtual) +
                          "       \n            "
                      ),
                      _c("strong", [_vm._v("Situação: ")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(this.situacao) +
                          "\n          "
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                    [
                      _c("strong", [_vm._v("Nº Protocolo: ")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(this.numProtocolo) +
                          "\n          "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                    [
                      _c("strong", [_vm._v("Rota / Sequência: ")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(this.numRota) +
                          "/" +
                          _vm._s(this.numSequencia) +
                          "\n          "
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                    [
                      _c("strong", [_vm._v("Tipo de Processo: ")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(this.desTipoProcesso) +
                          "\n          "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                    [
                      _c("strong", [_vm._v("Assunto: ")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(this.desAssunto) +
                          "\n          "
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                    [
                      _c("strong", [_vm._v("Requerente: ")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(this.nomRequerente) +
                          "\n          "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                    [
                      _c("strong", [_vm._v("Subassunto: ")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(this.desSubassunto) +
                          "\n          "
                      )
                    ]
                  )
                ]),
                _c("br"),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                    [_c("strong", [_vm._v("Local de origem ")])]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                    [_c("strong", [_vm._v("Localização atual ")])]
                  )
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6" },
                    [
                      _c("strong", [_vm._v("Órgão: ")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(this.desOrgao) +
                          "\n          "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6" },
                    [
                      _c("strong", [_vm._v("Órgão: ")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(this.desOrgaoAtual) +
                          "\n          "
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                    [
                      _c("strong", [_vm._v("Unidade: ")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(this.desUnidade) +
                          "\n          "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                    [
                      _c("strong", [_vm._v("Unidade: ")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(this.desUnidadeAtual) +
                          "\n          "
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                    [
                      _c("strong", [_vm._v("Setor: ")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(this.desSetor) +
                          "\n          "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" },
                    [
                      _c("strong", [_vm._v("Setor: ")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(this.desSetorAtual) +
                          "\n          "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-sm-1 text-right" },
                    [
                      _c("q-tooltip", [_vm._v("Histórico de Movimentação")]),
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            id: "visualizarHistorico",
                            name: "visualizarHistorico",
                            icon: "fas fa-history",
                            color: "primary",
                            flat: ""
                          },
                          on: { click: _vm.visualizarHistorico }
                        },
                        [_vm._v("  Histórico\n            ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-sm-1 text-right" },
                    [
                      _c("q-tooltip", [
                        _vm._v("Comprovante de encaminhamento")
                      ]),
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            id: "imprimirComprovanteEncaminhamento",
                            name: "imprimirComprovanteEncaminhamento",
                            icon: "fa fa-print",
                            color: "primary",
                            flat: ""
                          },
                          on: { click: _vm.imprimirComprovanteEncaminhamento }
                        },
                        [_vm._v("  Imprimir\n            ")]
                      )
                    ],
                    1
                  )
                ])
              ]),
              _c("q-card-separator"),
              _c(
                "q-tabs",
                {
                  staticClass: "mrg-t-10 mrg-l-10",
                  attrs: { inverted: "" },
                  model: {
                    value: _vm.abaSelecionada,
                    callback: function($$v) {
                      _vm.abaSelecionada = $$v
                    },
                    expression: "abaSelecionada"
                  }
                },
                [
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      label: "Observações",
                      name: "observacoes"
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      label: "Pendências",
                      name: "pendencias"
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      label: "Documentos",
                      name: "documentos"
                    },
                    slot: "title"
                  }),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "observacoes", "keep-alive": true } },
                    [
                      _c("observacoes", {
                        ref: "refObservacoes",
                        attrs: { paginaStatus: _vm.paginaStatus }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "pendencias", "keep-alive": true } },
                    [
                      _c("pendencias", {
                        ref: "refPendencias",
                        attrs: { paginaStatus: _vm.paginaStatus }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "documentos", "keep-alive": true } },
                    [
                      _c("documentos", {
                        ref: "refDocumentos",
                        attrs: { paginaStatus: _vm.paginaStatus }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-sm-6 text-right" },
            [
              _c("q-btn", {
                staticStyle: {
                  "margin-right": "10px",
                  "background-color": "#616161"
                },
                attrs: { id: "Fechar", name: "Fechar", label: "Fechar" },
                on: {
                  click: function($event) {
                    _vm.modalEditar = false
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }